import styled from 'styled-components';
import { Checkbox as MantineCheckbox } from '@mantine/core';

export const Checkbox = styled(MantineCheckbox)`
  --checkbox-size: 18px;

  .mantine-Checkbox-body {
    display: flex;
    align-items: center;
    gap: var(--space-100);
  }

  .mantine-Checkbox-label {
    padding: 0;
  }

  .mantine-Checkbox-input {
    /* border-radius: var(--radius-200); */
    border: 1px solid var(--border-color-default);
    background: var(--button-background);
    &:checked {
      border-color: var(--turquoise-400);
    }
  }

  .mantine-Checkbox-icon {
    color: var(--turquoise-400);

  }
  .mantine-Checkbox-label {
  }
`;
